import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import CampaignSelect from '@/components/common/form/CampaignSelect';
import ConfidenceLevelSelect from '@/components/common/form/ConfidenceLevelSelect';
import ControlledAssigneeSelect from '@/components/common/form/ControlledAssigneeSelect';
import ControlledSelect from '@/components/common/form/ControlledSelect';
import LabelSelect from '@/components/common/form/LabelSelect';
import StageSelect from '@/components/common/form/StageSelect';
import OpportunityFilter from '@/constants/opportunities/OpportunityQuickFilter';
import OpportunityStatus from '@/constants/OpportunityStatus';
import translate from '@/lib/intl/translate';

export default function QuickFilterOpportunity() {
  const { control } = useFormContext();

  return (
    <div className="grid w-80 grid-cols-1 gap-3 px-2 py-3">
      <Controller
        control={control}
        name={OpportunityFilter.OPPORTUNITY_STAGE_IDS}
        render={({ field: { value, onChange } }) => (
          <StageSelect onChange={onChange} value={value} multiple />
        )}
      />
      <ControlledAssigneeSelect
        name={OpportunityFilter.OWNER_IDS}
        label={translate('OPPORTUNITIES_OWNER_LABEL')}
        multiple
      />
      <Controller
        control={control}
        name={OpportunityFilter.OPPORTUNITY_LABEL_IDS}
        render={({ field: { onChange, value } }) => (
          <LabelSelect value={value} onChange={onChange} disableCloseOnSelect />
        )}
      />
      <Controller
        control={control}
        name={OpportunityFilter.CAMPAIGN_ID}
        render={({ field: { value, onChange } }) => (
          <CampaignSelect
            id="opportunity-campaign-select"
            multiple={false}
            onChange={onChange}
            value={value}
          />
        )}
      />
      <Controller
        control={control}
        name={OpportunityFilter.CONFIDENCE_LEVEL_IDS}
        render={({ field: { value, onChange } }) => (
          <ConfidenceLevelSelect onChange={onChange} value={value} multiple />
        )}
      />
      <FormControl className="w-full">
        <InputLabel id="opportunities-status-select-label">
          {translate('STATUS')}
        </InputLabel>
        <ControlledSelect
          control={control}
          name={OpportunityFilter.ARCHIVED}
          label={translate('STATUS')}
          labelId="opportunities-status-select-label"
          id="opportunities-status-select"
        >
          <MenuItem value="all">{translate('ALL')}</MenuItem>
          <MenuItem value={OpportunityStatus.ACTIVE}>
            {translate('OPPORTUNITIES_STATUS_ACTIVE')}
          </MenuItem>
          <MenuItem value={OpportunityStatus.ARCHIVED}>
            {translate('OPPORTUNITIES_STATUS_ARCHIVED')}
          </MenuItem>
        </ControlledSelect>
      </FormControl>
    </div>
  );
}
